import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe('pk_test_51Ie7BmEcTuv5eeGD8FI1dhfnxTJC6p4C3iky1smJWwz80uf7ixuCLiYO7CUzJPQQXrym2o69FtkHnZNgG7F9fWqv004nuCSKoK');

const Payment = () => {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm />
        </Elements>
    );
};

export default Payment;